// extracted by css-extract-rspack-plugin
export default {"footerNavSeparator":"footer-nav-separator--w_JJ1Xx3OfQNQVNe","abstractLinkLoading":"abstract-link-loading--eo1rnX8t81sm7U_X"};